module.exports = __webpack_public_path__ + "static/customer-journey-map-current-state-05dc7d65ae2e2dc6b28d6e2641d153e9.jpg";